import { Slide, Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const CategoryCard = ({title,image,link}) => {
  return (
    <div className="col-lg-2 col-md-4 col-6 fade-zoom">
      <Zoom>
        <div className="text-center mb-10">
          {/* img */}
          <Link to={link}>
            <img
              src={image}
              alt={title}
              className="card-image rounded-circle"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
              }}
            />
          </Link>
          {/* text */}
          <div className="mt-4">
            <h5 className="fs-6 mb-0">
              {" "}
              <Link to={link} className="text-inherit">
                {title}
              </Link>
            </h5>
          </div>
        </div>
      </Zoom>
    </div>
  );
};

export default CategoryCard